import React from "react";
import { AppBar, Dialog, Slide, Toolbar } from "@mui/material";
import CustomMuiDataTable from "src/Components/CustomMuiDataTable";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StatusDialog = ({
  statusVisible,
  handleCloseStatusModal,
  statusData,
  statusColumns,
  statusOptions
}) => {
  return (
    <Dialog
      fullScreen
      open={statusVisible}
      onClose={handleCloseStatusModal}
      TransitionComponent={Transition}
      style={{ zIndex: 2235 }}
    >
      <AppBar className="position-relative">
        <Toolbar>
          <button
            type="button"
            className="close-modal-button"
            onClick={handleCloseStatusModal}
          >
            &times;
          </button>
          <h4 className="text-white mx-3 my-0">Statuses</h4>
        </Toolbar>
      </AppBar>
      <div style={{ padding: "25px" }}>
        <CustomMuiDataTable
          title={"Statuses"}
          data={statusData}
          columns={statusColumns}
          options={statusOptions}
        />
      </div>
    </Dialog>
  );
};

export default StatusDialog; 